<div class="tiny-tag"><slot></slot></div>